import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/comparisons', label: 'Comparisons' },
    { path: '/integrations', label: 'Integrations' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <img src="/images/knine-logo.svg" alt="kNine logo" style={{ width: '40px', height: '40px', borderRadius: 'var(--radius)' }} />
          <span>kNine<span style={{ color: 'var(--primary)' }}>.ai</span></span>
        </Link>

        <div className="navbar-links">
          {navLinks.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={`navbar-link ${isActive(path) ? 'active' : ''}`}
            >
              {label}
            </Link>
          ))}
        </div>

        <div className="navbar-actions">
          <a
            href="https://app.knine.ai"
            className="btn btn-ghost btn-sm"
            target="_blank"
            rel="noopener noreferrer"
          >
            Log In
          </a>
          <a href="https://app.knine.ai/register" className="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer">
            Start Free Trial
          </a>
          <button
            className="navbar-mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            )}
          </button>
        </div>
      </div>

      <div className={`navbar-mobile-menu ${mobileOpen ? 'open' : ''}`}>
        {navLinks.map(({ path, label }) => (
          <Link key={path} to={path} className="navbar-mobile-link">
            {label}
          </Link>
        ))}
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '16px', marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <a
            href="https://app.knine.ai"
            className="btn btn-ghost"
            target="_blank"
            rel="noopener noreferrer"
          >
            Log In
          </a>
          <a href="https://app.knine.ai/register" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
            Start Free Trial
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
